import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { CustomerEffects } from '@customer/state';

import { CustomerLookupDialogComponent } from './customer-lookup-dialog/customer-lookup-dialog.component';
import { CustomerLookupDialogGridComponent } from './customer-lookup-dialog/grid/grid.component';

@NgModule({
  declarations: [CustomerLookupDialogComponent, CustomerLookupDialogGridComponent],
  imports: [CommonModule, SharedModule, ComponentsModule, TranslocoModule, EffectsModule.forFeature([CustomerEffects])],
  exports: [CustomerLookupDialogComponent],
})
export class CustomerModule {}
